import {WYSIWYGSingleLineStructuredText} from '~/cms/components/WYSIWYG/_components/WYSIWYGSingleLineStructuredText'
import {HgArticleWYSIWYGStatistic} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'
import {wysiwygComponentVariants} from '../../_utils/variants'
import {type WysiwygStatisticsFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGStatisticProps = {
  statistics: WysiwygStatisticsFragment['statistics']
}

export const DatoWYSIWYGStatistic = ({statistics}: DatoWYSIWYGStatisticProps) => {
  const {statistic} = wysiwygComponentVariants()
  const datoStatistics = statistics.map(({number, blurb, unit}) => ({
    number: <WYSIWYGSingleLineStructuredText data={number} />,
    blurb: <WYSIWYGSingleLineStructuredText data={blurb} />,
    unit: unit && <WYSIWYGSingleLineStructuredText data={unit} />,
  }))

  return (
    <HgArticleWYSIWYGStatistic statistics={datoStatistics} className={statistic()} />
  )
}
